import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";
import "@jds/core/style.css";
import "@jds/token-jio/style.css";
import "@jds/react-engine/style.css";
import "./index.css";
import * as ExtendedIcons from "@jds/extended-icons";
import { Notifications, TokenProvider, registerIcons } from "@jds/core";
registerIcons(ExtendedIcons);

// import { Notifications, TokenProvider } from "@jds/core";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  // </React.StrictMode>
  <TokenProvider value={{ theme: "JioCloud" }}>
    <App />
    <Notifications.Container />
  </TokenProvider>
);
